<template>
  <div>
    <Modal name="settings">
      <div>
        {{ $t('camera') }}
        <CameraSelector @selected="changeCamera" />
      </div>
      <div>
        {{ $t('mic') }}
        <MicrophoneSelector @selected="changeMicrophone" />
      </div>
    </Modal>
    <button @click="$modal.show('settings')">
      {{ $t('settings') }}
    </button>
  </div>
</template>

<script>
import CameraSelector from '@/components/CameraSelector.vue';
import MicrophoneSelector from '@/components/MicrophoneSelector.vue';
import useCamera from '@/compositions/useCamera';
import useMicrophone from '@/compositions/useMicrophone';

export default {
  name: 'VideoRoomSettings',
  components: { MicrophoneSelector, CameraSelector },
  setup() {
    const { changeCamera } = useCamera();
    const { changeMicrophone } = useMicrophone();

    return {
      changeCamera,
      changeMicrophone,
    };
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
mic: Microphone
camera: Camera
settings: Settings
</i18n>

<i18n locale="ru" lang="yaml">
mic: Микрофон
camera: Камера
settings: Настройки
</i18n>
